import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { useNavigate } from 'react-router'

import { ToggleContainer, Button } from './styles'

const ToggleSwitch = ({
  setToggle,
}: {
  setToggle?: Dispatch<SetStateAction<string>>
}) => {
  const navigate = useNavigate()
  const [active, setActive] = useState<string>('class')

  useEffect(() => {
    if (setToggle) {
      setToggle(active)
      navigate('/')
    }
  }, [active])

  return (
    <ToggleContainer $active={active}>
      <Button
        $isActive={active === 'class'}
        onClick={() => setActive('class')}
        $width={155}
      >
        Clases Individuales
      </Button>
      <Button
        $isActive={active === 'course'}
        onClick={() => setActive('course')}
        $width={120}
      >
        Cursos
      </Button>
    </ToggleContainer>
  )
}

export default ToggleSwitch
